export default "__VITE_ASSET__D4TVbTvT__"